import { useEffect, useState } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT;

export const useCourseJobTracker = () => {
    const [jobData, setJobData] = useState<any>(null);
    const jobId = localStorage.getItem("course_job_id");

    useEffect(() => {
        const jobId = localStorage.getItem("course_job_id");
        if (!jobId) return;

        const interval = setInterval(async () => {
            try {
                const res = await axios.get(`${apiUrl}/api/prompts/get-job/${jobId}`);
                const data = res.data;

                console.log('job status=>', res?.data?.status);

                setJobData(data);

                if (data.status === "completed" || data.status === "failed") {
                    localStorage.removeItem("course_job_id");
                    clearInterval(interval);
                }

            } catch (err) {
                console.error("Job polling error", err);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [jobId]);

    return jobData;
};